export enum TabEvent {
  CLEAR_LEFT_TABS = 'CLEAR_LEFT_TABS',
  CLEAR_RIGHT_TABS = 'CLEAR_RIGHT_TABS',
  CLOSE_ALL = 'CLOSE_ALL',
  CLOSE_CURRENT = 'CLOSE_CURRENT',
  CLOSE_OTHER = 'CLOSE_OTHER',
  UPDATE_TABS = 'UPDATE_TABS'
}
